// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingPlaceholderParent":"bcv_a bib_wl","LoadingPlaceholder":"bcv_b bib_h","loading-placeholder":"bcv_c"};